var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
var StyledEmptyState = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 50px;\n  text-align: center;\n"], ["\n  margin-top: 50px;\n  text-align: center;\n"])));
export default (function (props) {
    return (_jsxs(StyledEmptyState, { children: [_jsx(EmptyStateHeadline, { children: props.headline }), props.text, _jsx(EmptyStateAction, { children: props.actions })] }));
});
var StyledEmptyStateHeadline = styled.h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 5px;\n"], ["\n  margin-bottom: 5px;\n"])));
var EmptyStateHeadline = function (props) {
    return props.children ? (_jsx(StyledEmptyStateHeadline, { children: props.children })) : null;
};
var StyledEmptyStateAction = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: 20px;\n"], ["\n  margin-top: 20px;\n"])));
var EmptyStateAction = function (props) {
    return props.children ? (_jsx(StyledEmptyStateAction, { children: props.children })) : null;
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map